export const BUSINESS = {
  name: "GK Wellness & Luxury Spa",
  shortName: "GK Wellness",
  tagline: "Relax • Rejuvenate • Revive",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_74cba41d-7f7a-4d69-9b36-585e3e4acaf1/artifacts/c0xitp52_gk%20luxury%20spa%20logo.png",
  phoneDisplay: "8050533116",
  phoneIntl: "+91 80505 33116",
  tel: "tel:+918050533116",
  whatsappNumber: "918050533116",
  website: "gkwellnesspa.com",
  websiteUrl: "https://gkwellnesspa.com/",
  address:
    "No. 739, 2nd Floor, Vijayanand Residency, SBI Bank Building, Singasandra, Bengaluru, Karnataka 560068",
  landmark: "Near Manipal County Road",
  area: "Singasandra, Bengaluru",
  mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    "GK Wellness & Luxury Spa, No. 739, 2nd Floor, Vijayanand Residency, SBI Bank Building, Singasandra, Bengaluru, Karnataka 560068"
  )}`,
};

export const createWhatsAppLink = (message) =>
  `https://wa.me/${BUSINESS.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  hero: "Hi GK Wellness, I'd like to book an appointment. Please share the available massage options and time slots.",
  general:
    "Hi GK Wellness, I'd like to book an appointment. Please share the available services, prices and time slots.",
  offer:
    "Hi GK Wellness, I'd like to claim the new spa opening 20% OFF offer. Please share the available services and time slots.",
  visit:
    "Hi GK Wellness, I'd like to visit your spa. Please share the available services and time slots.",
};

export const OFFER = {
  eyebrow: "NEW SPA OPENING OFFER",
  discount: "FLAT 20% OFF",
};

export const SERVICES = [
  {
    id: "swedish",
    name: "Swedish Massage",
    description:
      "The classic full-body massage with long, gentle strokes to help you unwind and let go of everyday tension.",
    image:
      "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcGElMjBtYXNzYWdlJTIwdHJlYXRtZW50fGVufDB8fHx8MTc5MDIyNjkyMnww&ixlib=rb-4.1.0&q=85",
    alt: "Soothing Swedish back massage in a calm spa room",
    message:
      "Hi GK Wellness, I'm interested in a Swedish Massage. Please share the available time slots and pricing.",
  },
  {
    id: "aroma",
    name: "Aroma Massage",
    description:
      "A calming massage paired with fragrant essential oils for a soothing, sensory relaxation experience.",
    image:
      "https://images.pexels.com/photos/9483565/pexels-photo-9483565.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Aroma massage with essential oils and soft spa lighting",
    message:
      "Hi GK Wellness, I'm interested in an Aroma Massage. Please share the available time slots and pricing.",
  },
  {
    id: "balinese",
    name: "Balinese Massage",
    description:
      "A traditional Indonesian-inspired massage blending gentle stretches and flowing strokes for deep relaxation.",
    image:
      "https://images.pexels.com/photos/36922916/pexels-photo-36922916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Peaceful Balinese-style spa ambience with warm natural decor",
    message:
      "Hi GK Wellness, I'm interested in a Balinese Massage. Please share the available time slots and pricing.",
  },
  {
    id: "lomi-lomi",
    name: "Lomi Lomi Massage",
    description:
      "A Hawaiian-inspired massage with long, rhythmic strokes that flow gently like ocean waves.",
    image:
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcGElMjBtYXNzYWdlJTIwdHJlYXRtZW50fGVufDB8fHx8MTc5MDIyNjkyMnww&ixlib=rb-4.1.0&q=85",
    alt: "Relaxing Lomi Lomi style massage therapy session",
    message:
      "Hi GK Wellness, I'm interested in a Lomi Lomi Massage. Please share the available time slots and pricing.",
  },
  {
    id: "deep-tissue",
    name: "Deep Tissue Massage",
    description:
      "A firmer massage with slow, focused pressure for those who prefer a more intensive experience.",
    image:
      "https://images.unsplash.com/photo-1696841212541-449ca29397cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxzcGElMjByZWxheGF0aW9uJTIwd2VsbG5lc3MlMjBzdG9uZXN8ZW58MHx8fHwxNzkwMjI2OTIyfDA&ixlib=rb-4.1.0&q=85",
    alt: "Deep tissue massage with warm wellness stones",
    message:
      "Hi GK Wellness, I'm interested in a Deep Tissue Massage. Please share the available time slots and pricing.",
  },
  {
    id: "thai",
    name: "Thai Massage",
    description:
      "A dynamic dry massage with assisted stretching and rhythmic pressure that leaves you feeling loose and refreshed.",
    image:
      "https://images.pexels.com/photos/18120174/pexels-photo-18120174.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Traditional Thai massage with assisted stretching",
    message:
      "Hi GK Wellness, I'm interested in a Thai Massage. Please share the available time slots and pricing.",
  },
  {
    id: "foot",
    name: "Foot Massage",
    description:
      "A relaxing foot and calf massage — the perfect treat after long hours on your feet.",
    image:
      "https://images.pexels.com/photos/9146381/pexels-photo-9146381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Calming foot massage treatment in a spa setting",
    message:
      "Hi GK Wellness, I'm interested in a Foot Massage. Please share the available time slots and pricing.",
  },
  {
    id: "head",
    name: "Head Massage",
    description:
      "A soothing head, neck and shoulder massage to help you switch off and de-stress.",
    image:
      "https://images.unsplash.com/photo-1706795034830-de41aee06afa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxoZWFkJTIwbWFzc2FnZXxlbnwwfHx8fDE3OTAyMjgyODZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Professional therapist massaging temples and scalp during a luxury head massage",
    message:
      "Hi GK Wellness, I'm interested in a Head Massage. Please share the available time slots and pricing.",
  },
  {
    id: "jacuzzi",
    name: "Jacuzzi Experience",
    description:
      "Unwind in a warm, private jacuzzi soak — the perfect addition to your wellness visit.",
    image:
      "https://images.unsplash.com/photo-1571456803038-80efbf5c9d6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBqYWN1enppJTIwc3BhJTIwYmF0aHxlbnwwfHx8fDE3OTAyMjY5Mjd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Private jacuzzi bath in a luxury spa",
    message:
      "Hi GK Wellness, I'm interested in the Jacuzzi experience. Please share the available time slots and pricing.",
  },
];

// SAMPLE REVIEWS — placeholder content requested by the owner for launch.
// Replace with real Google reviews (or connect a Google Business Profile review feed) as they come in.
export const REVIEWS = [
  {
    name: "Rohit M.",
    rating: 5,
    text: "Booked through WhatsApp and got a slot the same day. The spa is clean, calm and the deep tissue massage was exactly what I needed after a long week.",
  },
  {
    name: "Priyanka S.",
    rating: 5,
    text: "Lovely new spa near Manipal County Road. The aroma massage was so relaxing and the staff were warm and professional. The opening offer made it great value too.",
  },
  {
    name: "Ananya R.",
    rating: 4,
    text: "Nice ambience and easy to find above the SBI Bank building in Singasandra. The foot massage was really good. Will be back to try the jacuzzi.",
  },
];

export const FAQS = [
  {
    q: "What services does GK Wellness offer?",
    a: "GK Wellness offers Swedish, Aroma, Balinese, Lomi Lomi, Deep Tissue, Thai, Foot and Head massage experiences, along with a Jacuzzi experience.",
  },
  {
    q: "Where is GK Wellness & Luxury Spa located?",
    a: "GK Wellness is located at No. 739, 2nd Floor, Vijayanand Residency, SBI Bank Building, Singasandra, Bengaluru, near Manipal County Road.",
  },
  {
    q: "How can I book an appointment?",
    a: "You can book by contacting GK Wellness through WhatsApp or phone.",
  },
  {
    q: "How do I contact GK Wellness on WhatsApp?",
    a: "You can WhatsApp GK Wellness at 8050533116.",
  },
  {
    q: "Is the new spa opening offer available?",
    a: "The landing page currently promotes the New Spa Opening — Flat 20% OFF offer. Customers can WhatsApp the spa for current availability and offer details.",
  },
];

export const IMAGES = {
  hero: {
    src: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcGElMjBtYXNzYWdlJTIwdHJlYXRtZW50fGVufDB8fHx8MTc5MDIyNjkyMnww&ixlib=rb-4.1.0&q=85",
    alt: "Relaxing luxury spa massage treatment with warm stones and orchid flowers",
  },
  about: {
    src: "https://images.pexels.com/photos/1926811/pexels-photo-1926811.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Calm spa interior with candles and neatly rolled towels",
  },
  gallery: [
    {
      src: "https://images.pexels.com/photos/6186740/pexels-photo-6186740.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Serene spa treatment room interior",
      caption: "Calm Spa Interiors",
    },
    {
      src: "https://images.pexels.com/photos/6903222/pexels-photo-6903222.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Warm jacuzzi hydro wellness bath",
      caption: "Jacuzzi Wellness",
    },
    {
      src: "https://images.pexels.com/photos/9483565/pexels-photo-9483565.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Aromatherapy essential oils prepared for a massage",
      caption: "Aromatherapy Rituals",
    },
    {
      src: "https://images.pexels.com/photos/36922916/pexels-photo-36922916.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      alt: "Peaceful spa ambience with warm natural decor",
      caption: "Quiet Ambience",
    },
  ],
};
